<template>
  <div>
    <div class="search-bar">
      <div class="search-bar__container">
        <div class="search-bar__icons">
            <transition name="slide">

          <Menu v-if="hamburgerMenu" />
            </transition>
          <div :class="hamburgerMenu? 'search-bar__hamburgerContainer search-bar__hamburgerContainer--fixed' : 'search-bar__hamburgerContainer'">
          <TastyBurgerButton
            type="spin"
            :size='size'
            color="white"
            activeColor="white"
            v-on:toggle="onToggle"

          />
          </div>
          <span class="icons__divide" />
          <div class="search-bar__search-icon" v-on:click="event => toggleSearch(event)"></div>
        </div>

        <a href="//www.polskieradio.pl" target="_blank">
          <div class="search-bar__logo"></div>
        </a>
        <div class="search-bar__relative">
        <div class="search-bar__login-icon" @click="editProfile" />
         
        </div>
      </div>
    </div>
    <SearchDropdownMobile/> 
  </div>
</template>

<script>
import SearchDropdownMobile from "@/components/SearchDropdown/Mobile/SearchDropdownMobile";
import Menu from "@/components/Menu/Mobile/Menu";

import mixin from "../mixin";
import { TastyBurgerButton } from "vue-tasty-burgers";
// import "vue-tasty-burgers/dist/vue-tasty-burgers.css";

export default {
  mixins: [mixin],
  components: {
    SearchDropdownMobile,
    TastyBurgerButton,
    Menu
  }
};
</script>

<style scoped lang="scss">
.search-bar {
  height: 3.8125rem;
  background-color: rgba(25, 30, 42, 0.4);
  &__hamburgerContainer {
    z-index: 100;
    &--fixed {
      position: fixed;
    }
  }
  &__container {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;
  }
  &__relative {
    position: relative;
        margin-right: 3%;
            margin-left: calc(4.4rem - 3%);


  }
  &__logo {
    width: 12rem;
    height: 2rem;
    background-image: url("/img/logoPRSA.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;

  }
  &__icons {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 3%;
    justify-content: space-between;
    width: 8rem;
  }
  &__search-icon {
   width: 2.3rem;
    height: 2.3rem;
    background-image: url(/icons/search.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
}
  &__login-icon {

    background-image: url("~@/assets/loginIcon__mobile.png");

    width: 3.6rem;
    height: 3.6rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    position: relative;
    align-self: flex-start;
  }
  .dropdown {
    position: absolute;
    bottom: -12rem;
    right: 0;
    background-color: #ffffff;
    overflow: hidden;
    z-index: 100;
    &__item {
      width: 7rem;
      padding: 1rem 2rem;
      font-family: "Poppins", sans-serif;
      text-align: center;
      &:not(:first-child) {
        border-top: 1px solid #b3bdda;
      }
    }
    &__list {
      display: flex;
      flex-direction: column;
    }
  }
  .icons__divide {
    display: block;
    height: 2rem;
    width: 1px;
    background-color: #df2860;
  }
  .slide-enter-active, .slide-leave-active {
  transition: transform .5s;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform:translateY(-100vh)
}
}
</style>
